(() => {
  const initializeAbra = () => {
    if (!window.Abra) return;
    window.Abra.useSellingPlanPriceOnProductBlock = false;
    if (window.Abra?.render) {
      window.Abra.render();
    }
  };

  const addClasses = () => {
    document.querySelector('.sls-option-container[data-prepaid="false"]:has([data-one-time-option-radio])')?.classList.add('one-time-purchase');
    document.querySelector('.sls-option-container[data-selling-plan-group-id]')?.classList.add('subscribe');
  };

  if (window.Abra) {
    initializeAbra();
  } else {
    const checkAbra = setInterval(() => {
      if (window.Abra) {
        clearInterval(checkAbra);
        initializeAbra();
      }
    }, 100);
    setTimeout(() => clearInterval(checkAbra), 5000);
  }

  addClasses();

  document.body.addEventListener('click', (e) => {
    if (!window.Abra) return;

    const oneTimeContainer = e.target.closest('.sls-option-container.one-time-purchase') || 
                             e.target.closest('.sls-option-container[data-prepaid="false"]:not([data-selling-plan-group-id])');

    const subscribeContainer = e.target.closest('.sls-option-container[data-selling-plan-group-id]') || 
                               e.target.closest('.sls-option-container.subscribe');

    const isOneTimeRadio = !!oneTimeContainer;
    const isSubscribeRadio = !!subscribeContainer && !isOneTimeRadio;

    if (isOneTimeRadio || isSubscribeRadio) {
      window.Abra.useSellingPlanPriceOnProductBlock = isSubscribeRadio;
      setTimeout(() => window.Abra?.render(), 500);
      setTimeout(() => {
        if (window.Abra) {
          window.Abra.useSellingPlanPriceOnProductBlock = isSubscribeRadio;
          window.Abra.render();
        }
      }, 1000);
    }
  }, true);

  new MutationObserver(() => {
    addClasses();
  }).observe(document.body, { childList: true, subtree: true });
})();
